import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import * as HiIcons from 'react-icons/hi';
import { clearUsersMessages, editUser, getUserById } from '../../../redux/rootActions';
import { RootState } from '../../../redux/rootReducer';
import Loader from '../../../assets/svg/Loader';
import { useHistory, useParams } from 'react-router-dom';
import UsersSuccessModal from '../../modals/UsersSuccessModal';
interface paramsType {
    id: string;
}
export default function EditUser() {
    const dispatch = useDispatch();
    const history = useHistory();
    const params = useParams<paramsType>();
    const user = useSelector((state: RootState) => state.users.User);
    const isEditLoading = useSelector((state: RootState) => state.users.isEditLoading);
    const updateError = useSelector((state: RootState) => state.users.editUserError);
    const updateSuccessMessage = useSelector(
        (state: RootState) => state.users.UserUpdateSuccessMessage
    );
    const deleteError = useSelector((state: RootState) => state.users.deleteUserError);
    const deleteSuccessMessage = useSelector(
        (state: RootState) => state.users.UserDeleteSuccessMessage
    );
    const formRef = useRef<any>();
    const [createSuccessVisible, setCreateSuccessVisible] = useState(false);
    const [category, setCategory] = useState<string>('Select a role');
    const [dropdownVisible, setDropdownVisible] = useState(false);

    const categoryOptions = [
        { id: 0, val: 'SLASSCOM Admin' },
        { id: 1, val: 'Company Admin' },
        { id: 2, val: 'Institute Admin' },
        { id: 3, val: 'Student' },
    ];
    useEffect(() => {
        dispatch(getUserById(params.id));
    }, [dispatch, params.id]);

    const handleClearMessages = useCallback(() => {
        if (updateError || updateSuccessMessage || deleteError || deleteSuccessMessage) {
            setCreateSuccessVisible(true);
        }
    }, [dispatch, updateSuccessMessage, deleteError, deleteSuccessMessage, updateError, history]);
    const handleClose = () => {
        dispatch(clearUsersMessages());
        if (!updateError) {
            history.push('/admin/users');
        }
    };
    useEffect(() => {
        handleClearMessages();
    }, [handleClearMessages]);

    return (
        <div className="mx-6 lg:ml-0 h-full">
            <div className="mt-12 bg-snow-600">
                <div className="mt-12">
                    <div className="relative">
                        <Formik
                            enableReinitialize={true}
                            innerRef={formRef}
                            initialValues={{
                                userName: user?.userName,
                                firstName: user?.firstName,
                                status: user?.status,
                                email: user?.contact?.emailId,
                                roles: user?.roles[0]?.roleName,
                            }}
                            validationSchema={Yup.object({
                                userName: Yup.string()
                                    .max(100, 'userName should be less than 100 characters')
                                    .required('userName is required'),
                                firstName: Yup.string()
                                    .max(100, 'FirstName should be less than 100 characters')
                                    .required('FirstName is required'),
                                email: Yup.string()
                                    .email('Invalid email')
                                    .required('Email is required'),
                                roles: Yup.string().required('Role is required'),
                            })}
                            onSubmit={async values => {
                                dispatch(
                                    editUser(user?.id, {
                                        userName: values.userName.trim(),
                                        firstName: values.firstName.trim(),
                                        status: values.status,
                                        contact: {
                                            emailId: values.email,
                                        },
                                        roles: [
                                            {
                                                roleName: values.roles,
                                            },
                                        ],
                                    })
                                );
                            }}
                        >
                            {({ handleSubmit, setFieldValue, values, errors, touched }) => (
                                <>
                                    <div className="flex justify-between items-center ml-4 mb-4 md:mb-6">
                                        <p className="text-xl font-semibold text-left">Edit User</p>
                                    </div>
                                    <div className="px-6 lg:px-12 pt-2 pb-4 mb-6">
                                        <div className="mb-2 md:mb-4">
                                            <div className="mb-6 w-full md:mb-0 flex my-4">
                                                <label
                                                    htmlFor="firstName"
                                                    className={`flex items-start w-1/4 block font-medium leading-149 text-sm md:text-base text-gray-700`}
                                                >
                                                    Name
                                                    <div className="text-red-600">*</div>
                                                </label>

                                                <div className="flex flex-col w-full">
                                                    <input
                                                        className={`rounded-sm flex items-center focus:outline-none w-3/4 md:w-4/5 p-2 border-2 text-base focus:border-blue-900 ${
                                                            errors.firstName && touched.firstName
                                                                ? 'border-red-500'
                                                                : 'border-gray-300'
                                                        } md:text-base`}
                                                        id="firstName"
                                                        type="text"
                                                        value={values.firstName}
                                                        onChange={e => {
                                                            setFieldValue(
                                                                'firstName',
                                                                e.target.value
                                                            );
                                                        }}
                                                        autoComplete="off"
                                                    />
                                                    {errors.firstName && touched.firstName ? (
                                                        <div className="text-red-500 text-xs my-1">
                                                            {errors.firstName}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="mb-6 w-full md:mb-0 flex my-4">
                                                <label
                                                    htmlFor="userName"
                                                    className={`flex items-start w-1/4 block font-medium leading-149 text-sm md:text-base text-gray-700`}
                                                >
                                                    UserName
                                                    <div className="text-red-600">*</div>
                                                </label>

                                                <div className="flex flex-col w-full">
                                                    <input
                                                        className={`rounded-sm flex items-center focus:outline-none w-3/4 md:w-4/5 p-2 border-2 text-base focus:border-blue-900 ${
                                                            errors.userName && touched.userName
                                                                ? 'border-red-500'
                                                                : 'border-gray-300'
                                                        } md:text-base`}
                                                        id="userName"
                                                        type="text"
                                                        value={values.userName}
                                                        onChange={e => {
                                                            setFieldValue(
                                                                'userName',
                                                                e.target.value
                                                            );
                                                        }}
                                                        autoComplete="off"
                                                    />
                                                    {errors.userName && touched.userName ? (
                                                        <div className="text-red-500 text-xs my-1">
                                                            {errors.userName}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="mb-6 w-full md:mb-0 flex my-4">
                                                <label
                                                    htmlFor="email"
                                                    className={`flex items-start w-1/4 block font-medium leading-149 text-sm md:text-base text-gray-700`}
                                                >
                                                    Email
                                                    <div className="text-red-600">*</div>
                                                </label>

                                                <div className="flex flex-col w-full">
                                                    <input
                                                        className={`rounded-sm flex items-center focus:outline-none w-3/4 md:w-4/5 p-2 border-2 text-base focus:border-blue-900 ${
                                                            errors.email && touched.email
                                                                ? 'border-red-500'
                                                                : 'border-gray-300'
                                                        } md:text-base`}
                                                        id="email"
                                                        type="text"
                                                        value={values.email}
                                                        onChange={e => {
                                                            setFieldValue('email', e.target.value);
                                                        }}
                                                        autoComplete="off"
                                                    />
                                                    {errors.email && touched.email ? (
                                                        <div className="text-red-500 text-xs my-1">
                                                            {errors.email}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="mb-6 w-full md:mb-0 flex my-4">
                                                <label
                                                    htmlFor="title"
                                                    className={`flex items-start w-1/4 block font-medium leading-149 text-sm md:text-base text-gray-700`}
                                                >
                                                    User Role
                                                    <div className="text-red-600">*</div>
                                                </label>

                                                <div className="flex flex-col w-full">
                                                    <div
                                                        className={`rounded-md flex relative cursor-pointer items-center focus:outline-none w-4/5 md:p-2 border-2 text-sm focus:border-blue-900 ${
                                                            errors.roles && touched.roles
                                                                ? 'border-red-500'
                                                                : 'border-gray-300'
                                                        } md:text-base`}
                                                    >
                                                        <div
                                                            className="flex justify-between w-full"
                                                            onClick={() => setDropdownVisible(true)}
                                                        >
                                                            <div className="text-gray-700 font-medium pl-2">
                                                                {category}
                                                            </div>
                                                            <div className="">
                                                                <div className="flex flex-col">
                                                                    <HiIcons.HiChevronUp className="mr-2 -mb-2" />
                                                                    <HiIcons.HiChevronDown className="mr-2" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {dropdownVisible ? (
                                                            <ul
                                                                className="absolute w-full cursor-pointer top-11 pl-0 left-0 z-10 rounded-md shadow-md py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                                                                role="menu"
                                                                onMouseLeave={() =>
                                                                    setDropdownVisible(false)
                                                                }
                                                            >
                                                                {categoryOptions.map(action => (
                                                                    <div
                                                                        className="p-2 hover:bg-gray-200 "
                                                                        key={action.id}
                                                                        onClick={() => {
                                                                            setCategory(action.val);
                                                                            setFieldValue(
                                                                                'roles',
                                                                                action.id === 0
                                                                                    ? 'SLASSCOM_ADMIN'
                                                                                    : action.id ===
                                                                                      1
                                                                                    ? 'COMPANY_ADMIN'
                                                                                    : action.id ===
                                                                                      1
                                                                                    ? 'INSTITUTE_ADMIN'
                                                                                    : 'STUDENT'
                                                                            );
                                                                            setDropdownVisible(
                                                                                false
                                                                            );
                                                                        }}
                                                                    >
                                                                        {action.val}
                                                                    </div>
                                                                ))}
                                                            </ul>
                                                        ) : null}
                                                    </div>
                                                    {errors.roles && touched.roles ? (
                                                        <div className="text-red-500 text-xs my-1">
                                                            {errors.roles}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex justify-end items-center mb-4 md:mb-6">
                                        <div className="flex w-1/2 lg:w-1/3 h-16">
                                            <button
                                                className="md:py-3 bg-snow-900 border-2 border-blue-800 border-opacity-40 text-blue-700 font-medium text-sm rounded w-full md:w-1/3 my-2 focus:outline-none"
                                                onClick={() => history.push('/admin/users/')}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                type="submit"
                                                className="md:py-3 mx-6 lg:mx-8 bg-blue-700 text-white text rounded w-full md:w-1/2 my-2 focus:outline-none"
                                                onClick={() => handleSubmit()}
                                            >
                                                {isEditLoading ? <Loader /> : 'Add User'}
                                            </button>
                                        </div>
                                    </div>
                                    {createSuccessVisible && (
                                        <UsersSuccessModal
                                            modalVisible={createSuccessVisible}
                                            handleClose={handleClose}
                                        />
                                    )}
                                </>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </div>
    );
}
